// This file is generated by scripts/sync-articles.mjs. Do not edit it by hand.

const discoveredArticles = [
  {
    "slug": "when-ai-can-do-the-analysis-expertise-becomes-the-advantage",
    "title": "When AI Can Do the Analysis, Expertise Becomes the Advantage",
    "by": "Mohamed Gad",
    "date": "2026-10-24",
    "category": "Data & Analytics",
    "topics": [
      "Data Science",
      "Management",
      "Domain Expertise",
      "Artificial Intelligence",
      "Decision Intelligence",
      "Future of Work"
    ],
    "summary": "As AI takes on more analytical work, the opportunity is to combine deep expertise in a field with data science, critical evaluation, and management judgment. An interactive exploration of context, validation, and the professional value of connecting evidence to real decisions.",
    "cover_image": "https://static.wixstatic.com/media/676771_aa29eae8e04c4a579a43329325aaf3b5~mv2.jpg/v1/fill/w_568,h_378,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/676771_aa29eae8e04c4a579a43329325aaf3b5~mv2.jpg",
    "cover_is_ready": true,
    "loadContent": () => import(/* webpackChunkName: "article-when-ai-can-do-the-analysis-expertise-becomes-the-advantage" */ "./Article48.jsx")
  },
  {
    "slug": "when-every-sailor-follows-a-different-wind",
    "title": "When Every Sailor Follows a Different Wind",
    "by": "Mohamed Gad",
    "date": "2026-10-10",
    "category": "Leadership & Growth",
    "topics": [
      "Leadership",
      "Strategic Alignment",
      "Decision-Making",
      "Organizational Dynamics",
      "Change Management"
    ],
    "summary": "When capable people follow competing priorities, even a strong organization can drift off course. A maritime exploration of leadership, alignment, dissent, and the difficult decisions required to correct direction.",
    "cover_image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPqN3RDqEo-0J7o10RDhKAfV_I5T2UnIUK6ZZdrK9LDA&s=10",
    "cover_is_ready": true,
    "loadContent": () => import(/* webpackChunkName: "article-when-every-sailor-follows-a-different-wind" */ "./Article47.jsx")
  }
];

export default discoveredArticles;
